export default [
    { label: 'Western Australia', lat: '-26.998542', lng: '116.041546', value: '10', zoom: '5' },
    { label: 'Perth Metropolitan', lat: '-31.664758', lng: '115.686856', value: '1', zoom: '9' },
    { label: 'Goldfields Midlands', lat: '-29.747658', lng: '119.065355', value: '2', zoom: '7' },
    { label: 'Kimberley', lat: '-15.466044', lng: '121.917047', value: '3', zoom: '7' },
    { label: 'Pilbara', lat: '-22.096284', lng: '114.960824', value: '4', zoom: '7' },
    { label: 'Midwest Gascoyne', lat: '-21.246860', lng: '114.015838', value: '5', zoom: '7' },
    { label: 'Great Southern', lat: '-33.010335', lng: '117.400508', value: '6', zoom: '8' },
    { label: 'South West', lat: '-32.894535', lng: '114.992566', value: '7', zoom: '9' },
    { label: 'Lower South West', lat: '-33.810951', lng: '114.917543', value: '8', zoom: '9' },
    { label: 'Upper Great Southern', lat: '-33.336976', lng: '117.943833', value: '9', zoom: '9' },
];
